import { Routes, Route } from 'react-router-dom';
import Invest from './pages/Invest';
import Admin from './pages/Admin';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Invest />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

export default App;
